import PropTypes from 'prop-types';
import React from 'react';
import searchChoiceButtonStyles from './SearchChoiceButton.module.scss';

export default function SearchChoiceButton({
  dataType,
  eventHandler,
  option,
}) {
  if (option.url) {
    return (
      <a
        key={option.key}
        className={searchChoiceButtonStyles.searchChoiceButton}
        data-type={dataType}
        href={option.url}
        onClick={eventHandler}
        onKeyDown={eventHandler}
        tabIndex={0}
      >
        {option.title}
      </a>
    );
  }

  return (
    <button
      key={option.key}
      className={searchChoiceButtonStyles.searchChoiceButton}
      data-type={dataType}
      onClick={eventHandler}
      onKeyDown={eventHandler}
      tabIndex={0}
      type="button"
      value={option.title}
    >
      {option.title}
    </button>
  );
}

SearchChoiceButton.propTypes = {
  dataType: PropTypes.string.isRequired,
  option: PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
  }),
  eventHandler: PropTypes.func.isRequired,
};
